import React from "react";
import {
  InputGroup,
  InputLeftElement,
  Icon,
  Input,
  InputRightElement,
  IconButton,
} from "@chakra-ui/react";
import { SearchIcon, XIcon } from "@heroicons/react/outline";
import propTypes from "prop-types";

const FilterInput = ({ onClear, id, ...props }) => {
  return (
    <InputGroup {...props} colorScheme={"brand.primary"}>
      <InputLeftElement>
        <Icon as={SearchIcon} color="gray.300" />
      </InputLeftElement>

      <Input data-testid={`filter-input-${id}`} id={id} {...props} />

      {props.value && (
        <InputRightElement>
          <IconButton
            aria-label="Clear Search"
            onClick={onClear}
            size="sm"
            variant="ghost"
          >
            <Icon as={XIcon} color="gray.300" fontSize="1.5em" />
          </IconButton>
        </InputRightElement>
      )}
    </InputGroup>
  );
};

FilterInput.propTypes = {
  id: propTypes.string,
  onChange: propTypes.func,
  onClear: propTypes.func,
  placeholder: propTypes.string,
  value: propTypes.string,
};

export default FilterInput;
